<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">OK-app emulator</h1>
  </div>
</div>
<div class="comp-main map-container">
  @if (locationStats && showLocationStats) {
    <adm-location-stats
      [locationStats]="locationStats"
      [selectedChargingSpeeds]="chargingSpeedFilters"
      (chargingSpeedChange)="handleChargingSpeed($event)" />
  }
  <div>
    @if (mapReady()) {
      <google-map
        [zoom]="locationMapSettings.getValue().zoom"
        (boundsChanged)="boundsChanged(true)"
        (mapDragend)="boundsChanged(false)"
        [center]="{ lat: this.locationMapSettings.getValue().center.lat, lng: this.locationMapSettings.getValue().center.long }"
        [options]="options()!"
        (mapClick)="closeInfo()">
        @for (location of shownLocations(); track location) {
          <map-advanced-marker
            #marker="mapAdvancedMarker"
            [position]="{ lat: location.latitude, lng: location.longitude }"
            [title]="location.name"
            [content]="location.content"
            [gmpClickable]="true"
            (gmpClick)="openInfo(location, marker)" />
        }

        <map-info-window>
          @if (activeLocation) {
            <div class="map-container__active-location" #activeLocationContent>
              <div class="map-container__active-location--close" (click)="closeInfo()"><mat-icon>close</mat-icon></div>
              <div class="map-container__active-location--name">{{ activeLocation.name }}</div>
              <div class="map-container__active-location--address">{{ activeLocation.address }}</div>
              <span class="map-container__active-location--connector-count">
                {{ activeLocation.connectorCount }}
              </span>
              <div class="map-container__active-location--connector-info">
                @if (activeLocation.chargingSpeed === chargingSpeed.Normal) {
                  <mat-icon [style]="'width:inherit; height:inherit'" svgIcon="socket_type2"></mat-icon>
                }
                @if (activeLocation.chargingSpeed === chargingSpeed.Fast || activeLocation.chargingSpeed === chargingSpeed.Super) {
                  <mat-icon [style]="'width:inherit; height:inherit'" svgIcon="socket_type_ccs2"></mat-icon>
                }

                @if (activeLocation.chargingSpeed === chargingSpeed.Super) {
                  <span class="connector-speed">
                    <mat-icon>keyboard_double_arrow_right</mat-icon>
                  </span>
                }
                @if (activeLocation.chargingSpeed === chargingSpeed.Fast) {
                  <span class="connector-speed">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                  </span>
                }
                @if (activeLocation.maxChargingPowerOnLocation) {
                  <span class="max-connector-speed"> {{ activeLocation.maxChargingPowerOnLocation }} kWh </span>
                }
              </div>
              <div class="map-container__active-location--infolink">
                <a class="blue" (click)="openLocationDetails(activeLocation)">Information</a>
              </div>

              @if (activeLocation.visibilityComment) {
                <span class="map-container__active-location--obs" (click)="openComment(activeLocation)"> OBS </span>
              }
            </div>
          }
        </map-info-window>
      </google-map>
    }

    <div class="map-searches">
      <form [formGroup]="mapSearchForm">
        <mat-button-toggle-group
          class="map-searches__toggle-buttons"
          formControlName="mapSearchInputType"
          hideSingleSelectionIndicator="true">
          <label>Søg på:</label>
          <mat-button-toggle class="map-searches__toggle-button" value="address">Adresse</mat-button-toggle>
          <mat-button-toggle class="map-searches__toggle-button" value="mokUserNumber">MOK brugernr.</mat-button-toggle>
          <mat-button-toggle class="map-searches__toggle-button" value="deviceId">DeviceId</mat-button-toggle>
          <mat-button-toggle class="map-searches__toggle-button" value="customerNumber">Kundenr.</mat-button-toggle>
          <mat-button-toggle class="map-searches__toggle-button" value="location">Lokation</mat-button-toggle>
          <mat-button-toggle class="map-searches__toggle-button" value="chargingStationIdentifier">Ladestander id</mat-button-toggle>
        </mat-button-toggle-group>

        <mat-form-field class="map-searches__input">
          <svg class="icon-24 margin--right-xs" matPrefix><use href="assets/images/ok-icons-sprite.svg#search-s"></use></svg>
          <input
            #search
            matInput
            formControlName="mapSearchInput"
            type="text"
            placeholder="{{ placeHolderText }}"
            class="map-search__input"
            autocomplete="off"
            admClearTextDirective />

          @if (
            mapSearchInputType.value === 'mokUserNumber' ||
            mapSearchInputType.value === 'customerNumber' ||
            mapSearchInputType.value === 'deviceId'
          ) {
            <mat-checkbox
              matSuffix
              class="small no-wrap margin--left-m margin--right-m"
              formControlName="mapSearchOnlyShowMatchingLocations">
              Kun matches
            </mat-checkbox>
          }
        </mat-form-field>
      </form>
      @if (places.length > 0) {
        <div class="places" [class.reduce-height]="searchResultClicked">
          @for (place of places; track place) {
            <div class="place" (click)="gotoPlace(place)">
              <div class="place__icon">
                <mat-icon [matTooltip]="'Vis i app emulator'" class="google-maps-link-icon--center">travel_explore</mat-icon>
              </div>
              <div class="place__info">
                <div class="place__info--name">
                  {{ place.displayName }}
                </div>
                <div class="place__info--address">{{ place.formattedAddress }}</div>
              </div>
            </div>
          }
        </div>
      }
      @if (filteredLocations.length > 0) {
        <div class="places" [class.reduce-height]="searchResultClicked">
          @for (location of filteredLocations; track location) {
            <div class="place" (click)="gotoLocation(location)">
              <div class="place__icon">
                <img src="{{ location.content.src }}" width="32" height="32" alt="location" />
              </div>
              <div class="place__info">
                <div class="place__info--name">
                  {{ location.name }}
                </div>
                <div class="place__info--address">{{ location.address }}</div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
